export const itemsOrder  = [
    { label: "Empleados",                           value: '{"empleado.nombre": "ASC", "empleado.apellido1": "ASC", "empleado.apellido2": "ASC"}' },
    { label: "Día (De más reciente a más antiguo)", value: '{"fecha": "DESC"}' },
    { label: "Día (De más antiguo a más reciente)", value: '{"fecha": "ASC"}'  },
]